import * as yup from 'yup'

export const schema = yup.object().shape({
  status: yup.number().notRequired(),
  message: yup.string().notRequired().default(''),
})
